import React, { useState, useEffect,useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/solid';
import axios from '../../axios';
import NoImage from '../../assets/placeholder.jpg';
import imageAxios from '../../imageAxios';
import AuthContext from '../../AuthContext'
const TrainerDetails = () => {
  const navigate = useNavigate();
  const  auth=useContext(AuthContext)
  const location = useLocation();
  const { id } = location.state || {};
  const [ad, setAd] = useState('');
  const [pan, setPan] = useState('');
  const [cv, setCV] = useState('');
  const [exp, setExp] = useState('');
  const [qual, setQual] = useState('');
  const [trainer, setTrainer] = useState({});
  const [imgSrc, setImgSrc] = useState('');
  const[tot,setTot]=useState('')
  const handleError = () => {
    setImgSrc(NoImage); // Path to your fallback image
  };

  useEffect(() => {
    axios.get(`trainer/get/${id}`)
      .then((res) => {
        setTrainer(res.data);
        // console.log(res.data)
        setImgSrc(`${imageAxios}/${res.data.photo}`);
        setAd(res.data.aadhar_card ? `${imageAxios}/${res.data.aadhar_card}` : '');
        setPan(res.data.pan_card ? `${imageAxios}/${res.data.pan_card}` : '');
        setCV(res.data.cv ? `${imageAxios}/${res.data.cv}` : '');
        setTot(res.data.tot_document ? `${imageAxios}/${res.data.tot_document}` : '');
        setExp(res.data.experience_certificate ? `${imageAxios}/${res.data.experience_certificate}` : '');
        setQual(res.data.qualification_certificate ? `${imageAxios}/${res.data.qualification_certificate}` : '');
      })
      .catch((err) => console.log(err));
  }, [id]);

  const date = new Date(trainer.dob);
  const formattedDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });

  const handleView = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Document not found');
    }
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="flex items-center justify-between bg-gray-100 p-4 border-b border-gray-400">
            <div className="flex items-center space-x-2">
              <ArrowLeftIcon
                className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-800 transition"
                onClick={() => navigate('/trainer')}
              />
              <h1 className="text-xl font-semibold text-gray-700">Trainer Details</h1>
            </div>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              
              <div className="flex flex-col row-span-2">
                <div className="text-gray-800 font-bold">Profile Picture</div>
                <img
                  className="w-24 h-24 rounded-full object-cover"
                  src={imgSrc}
                  onError={handleError}
                  alt="Trainer Profile"
                />
              </div>
           
                  <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Trainer Code</div>
                <div className="text-gray-600">{trainer.trainer_code}</div>
              </div>
              
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Name</div>
                <div className="text-gray-600">{trainer.full_name}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Email</div>
                <div className="text-gray-600">{trainer.email}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Phone No.</div>
                <div className="text-gray-600">{trainer.mob_no}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Alternate Email</div>
                <div className="text-gray-600">{trainer.alt_email}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Alternate Phone No.</div>
                <div className="text-gray-600">{trainer.alt_mob_no}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Date of Birth</div>
                <div className="text-gray-600">{formattedDate}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Gender</div>
                <div className="text-gray-600">{trainer.gender}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Marital Status</div>
                <div className="text-gray-600">{trainer.marital_status}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Address</div>
                <div className="text-gray-600">{trainer.address}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">District</div>
                <div className="text-gray-600">{trainer.district}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Qualification</div>
                <div className="text-gray-600">{trainer.qualification}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Qualification Certificate</div>
                <div className="text-gray-600">
                  {qual ? (
                    <button
                      onClick={() => handleView(qual)}
                      className="text-blue-500 hover:underline"
                    >
                      View Qualification Certificate
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Experience</div>
                <div className="text-gray-600">{trainer.experience}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Experience Certificate</div>
                <div className="text-gray-600">
                  {exp ? (
                    <button
                      onClick={() => handleView(exp)}
                      className="text-blue-500 hover:underline"
                    >
                      View Experience Certificate
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Aadhar No.</div>
                <div className="text-gray-600">{trainer.aadhar_no}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Aadhar Card</div>
                <div className="text-gray-600">
                  {ad ? (
                    <button
                      onClick={() => handleView(ad)}
                      className="text-blue-500 hover:underline"
                    >
                      View Aadhar Card
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Pan No.</div>
                <div className="text-gray-600">{trainer.pan_no}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Pan Card</div>
                <div className="text-gray-600">
                  {pan ? (
                    <button
                      onClick={() => handleView(pan)}
                      className="text-blue-500 hover:underline"
                    >
                      View Pan Card
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Status</div>
                <div className="text-gray-600">{trainer.status}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Payment</div>
                <div className="text-gray-600">{trainer.payment}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">CV</div>
                <div className="text-gray-600">
                  {cv ? (
                    <button
                      onClick={() => handleView(cv)}
                      className="text-blue-500 hover:underline"
                    >
                      View CV
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
                
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">ToT Certificate</div>
                <div className="text-gray-600">
                  {tot ? (
                    <button
                      onClick={() => handleView(tot)}
                      className="text-blue-500 hover:underline"
                    >
                      View ToT Certificate
                    </button>
                  ) : (
                    'N/A'
                  )}
                </div>
                </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Username</div>
                <div className="text-gray-600">{trainer.username}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Courses</div>
                <div className="text-gray-600">{trainer.course_names}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Sector</div>
                <div className="text-gray-600">{trainer.sector_names}</div>
              </div>
              {
                (auth.userType==='Superadmin'||auth.userType==='Manager')&&(
                  <>
                  <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Centre Name</div>
                <div className="text-gray-600">{trainer.centre_name}</div>
              </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerDetails;
